import { Configuration, BaseUserApi, QrWifiApi } from '@/api';
import { axios } from 'hpsfir-managebase-ui';

interface BaseApi {
  baseUrl: string;
  uploadFileUrl: string;
  baseUserApi: BaseUserApi;
  qrWifiApi: QrWifiApi;
}

const api: BaseApi = {} as BaseApi;

export const initApi = (basePath: string) => {
  const apiConfig = new Configuration({
    basePath,
  });
  api.baseUrl = basePath;
  api.uploadFileUrl = '/upload/file';
  api.baseUserApi = new BaseUserApi(apiConfig, basePath, axios);
  api.qrWifiApi = new QrWifiApi(apiConfig, basePath, axios);
};

export const useApi = () => api;
